module.exports = __webpack_public_path__ + "static/img/touch.ba3be66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touch.png
// module id = 10
// module chunks = 0